export default class ArticleViewTrackerController {
    constructor() {
        this.init();
    }

    init() {
        // Get article ID from data attribute
        const articleId = this.getArticleId();
        
        if (!articleId) {
            return; // Not an article detail page
        }

        // Lazy load ArticleViewTracker class
        import(/* webpackChunkName: "ArticleViewTracker" */ "../classes/ArticleViewTracker")
            .then(({ default: ArticleViewTracker }) => {
                new ArticleViewTracker(articleId);
            })
            .catch(err => console.error("Error loading ArticleViewTracker:", err));
    }

    /**
     * Get article ID from data attribute
     */
    getArticleId() {
        // Try data attribute first (most reliable)
        const section = document.querySelector(".c-seo-article[data-article-id]");
        if (section) {
            const articleId = parseInt(section.getAttribute("data-article-id"), 10);
            if (articleId && articleId > 0) {
                return articleId;
            }
        }

        return null;
    }
}

